export default __webpack_public_path__ + "static/media/Ecommerce.c272cd81.png";